// extracted by mini-css-extract-plugin
export default {"wrap":"Ws-z","fullWidth":"Xs-z","items":"Ys-z","featureCss":"Zs-z","disabled":"_s-z","imgCss":"at-z"};